module.exports = __webpack_public_path__ + "static/media/jessica.e665f5ef.png";